/**
 * Erklaertext zu „Hey Jane“ — die EINE Stelle (Weckwort-Spec §5). Onboarding, Einstellungen,
 * Erklaerdialog und der Einmal-Hinweis im Jane-Panel (ai-chat) zeigen genau diesen Text.
 *
 * Aendert sich der Wortlaut, zaehlt `WECKWORT_HINWEIS_VERSION` hoch: die Einwilligung am Konto
 * (`user_preferences.jane_weckwort.hinweis_version`) belegt, welcher Text erklaert wurde
 * (Art. 7 Abs. 1 DSGVO), und eine aeltere gilt danach nicht mehr. Den Wortlaut prueft legal mit
 * (VVT Jane §11).
 */
export const WECKWORT_HINWEIS_VERSION = 1;

export const WECKWORT_HINWEIS_TEXT =
  "Wenn ‚Hey Jane‘ an ist, hört das Mikrofon dieses Browsers mit, solange eine Janeway-App sichtbar ist. " +
  "Die Erkennung läuft nur auf diesem Gerät, es wird nichts übertragen, bis du ‚Hey Jane‘ sagst. " +
  "Danach beginnt ein normales Gespräch mit Jane. " +
  "Du kannst es jederzeit am Jane-Knopf oder in den Einstellungen abschalten.";
